'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { track } from '@/lib/analytics';

interface CTAButtonProps {
  href: string;
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  small?: boolean;
  /** When set, clicking fires a CTA_CLICK analytics event with this label. */
  trackLabel?: string;
}

export function CTAButton({ href, children, variant = 'primary', small, trackLabel }: CTAButtonProps) {
  const pathname = usePathname();
  const className = `vn-btn vn-btn--${variant}${small ? ' vn-btn--small' : ''}`;
  return (
    <Link
      href={href}
      className={className}
      onClick={trackLabel ? () => track('CTA_CLICK', pathname, trackLabel) : undefined}
    >
      {children}
    </Link>
  );
}
